module.exports = __webpack_public_path__ + "img/ic-linechart-white.252c0d2f.svg";